module.exports = __webpack_public_path__ + "img/meredith-katz.bee61b86.png";